"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _needMoreInfo = require("../store/NeedMoreInfo/needMoreInfo.actions");

var _needMoreInfo2 = require("../store/NeedMoreInfo/needMoreInfo.selectors");

var useNeedMoreInfo = function useNeedMoreInfo(giftId) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var sendMoreInfo = (0, _react.useCallback)(function (info) {
    dispatch((0, _needMoreInfo.sendMoreInfoRequest)({
      giftId,
      info
    }));
  }, [dispatch, giftId]);
  var getErrors = (0, _reactRedux.useSelector)(_needMoreInfo2.getNeedMoreInfoErrors);
  var getIsLoading = (0, _reactRedux.useSelector)(_needMoreInfo2.getNeedMoreInfoIsLoading);
  return [sendMoreInfo, getIsLoading, getErrors];
};

var _default = useNeedMoreInfo;
exports.default = _default;